import { useFlags as useLDFlags } from "launchdarkly-react-client-sdk";
import { FlagNames, Flags } from "./flags";

export const useFlags = (): Flags => useLDFlags();

export const useFlag = (name: FlagNames): Flags[typeof name] => {
  const flags = useFlags();
  return flags[name];
};
